import { Routes } from '@angular/router'

import { projectAccessGuard } from '@flowx/designer/shared/guards/application-permissions.guards'

import { WorkspaceEntityRoutes } from './workspace-entity-routes'

import { MergeConflictsStore } from '../../merge-conflicts/stores/conflicts.store'
import { ApplicationMainLayoutRoutes } from '../../projects/application-main-layout-routes'

// `workspaceAccessGuard` on the parent route checks the workspace first.
export const WorkspaceRoutes: Routes = [
  // WORKSPACE ENTITY ADMINISTRATION ROTUES
  // projects, libraries, themes, fonts, global media library, audit logs, users, groups
  {
    path: '',
    loadComponent: () =>
      import('@flowx/designer/modules/workspaces/workspace/workspace-main.component').then(
        ({ WorkspaceMainComponent }) => WorkspaceMainComponent
      ),
    children: WorkspaceEntityRoutes,
  },
  // APPLICATION ROUTES
  // processes, project data model, uit templates, functions, enumerations, substitution tags, media library,
  // notification templates, document templates, document intelligence, views, stages, allocations rules, data sources,
  // workflows, dependencies, configuration parameters
  {
    path: 'projects',
    children: [
      {
        path: ':appId',
        loadComponent: () =>
          import('@flowx/designer/modules/layout/components/application-main-layout/application-main-layout.component').then(
            ({ FlxApplicationMainLayoutComponent }) => FlxApplicationMainLayoutComponent
          ),
        canActivate: [projectAccessGuard],
        providers: [MergeConflictsStore],
        children: ApplicationMainLayoutRoutes,
      },
    ],
  },
]
